// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","526":"pages-DebugPage","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"b74f996e062d529ca23c","192":"7815c38aa9f98eba8827","526":"e218b9f3318c267b01d4","777":"52938c646bd4987914f3"}[chunkId] + ".js";
};